import React from "react";

import { Dropdown } from "../utils/local-antd";
import type { DropdownProps, MenuProps } from "../utils/local-antd";

// The submenu-title override this component used to declare lives in
// GlobalStyle now. It was a createGlobalStyle rendered once per AtiraDropdown,
// which put one copy of the same rule in the shared stylesheet per mounted call
// site, and made every unmount rebuild that whole group: measured on 20
// instances, unmounting them cost 400 stylesheet mutations against 20 for
// mounting them. Route changes drop a lot of dropdowns at once. The rule never
// depended on props or theme, so one app-level declaration does the same job.

interface AtiraDropdownProps extends DropdownProps {
  children: React.ReactNode;
  items: MenuProps["items"];
  dataTestId?: string;
}

export const AtiraDropdown: React.FC<AtiraDropdownProps> = ({
  children,
  items,
  menu,
  trigger = ["click"],
  arrow = { pointAtCenter: true },
  ...props
}) => {
  return (
    <div data-testid={props.dataTestId}>
      <Dropdown
        menu={{ ...menu, items }}
        trigger={trigger}
        arrow={arrow}
        {...props}
      >
        {children}
      </Dropdown>
    </div>
  );
};
